import Computer_Science_And_Engineering from '../prefooter/computer_science_and_engineering/Computer_Science_And_Engineering'
import Information_Technology from '../prefooter/information_technology/Information_Technology'


  export  const allPreFooterMap = {
        "computer-science-and-engineering": {
            h1: "Top Engineering Colleges for Computer Science Engineering",
            preFooter: <Computer_Science_And_Engineering />
        },
         "information-technology": {
            h1: "Best Information Technology Engineering College",
            preFooter: <Information_Technology />
        }
    }



